
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"clip-path":"url(#clip0_1477_267)"}},[_c('rect',{attrs:{"width":"20","height":"20","rx":"10","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16 6.437L8.35 14 5 10.69l.442-.438 2.907 2.873L15.558 6l.442.437z","fill":"#4CAF50"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1477_267"}},[_c('rect',{attrs:{"width":"20","height":"20","rx":"10","fill":"#fff"}})])])])
      }
    
      }
    